"use strict";

let $infoToast;

function updateTopOffset() {
    const nav = document.querySelector('.js-affix-nav');

    if (!nav) {
        return;
    }

    /* im affixed Zustand steht die Navbar fix am oberen Rand, sonst liegt ihre Unterkante
       inkl. Notification-Bar tiefer - der größere Wert verhindert die Überlappung in beiden Fällen */
    const top = Math.max(nav.getBoundingClientRect().bottom, nav.offsetHeight) + 10;
    document.documentElement.style.setProperty('--info-toast-top', `${top}px`);
}

export function initInScope($scope) {
    const $toast = $scope.find('.js-toast');

    if (!$toast.length) {
        return;
    }

    $infoToast = $toast;

    const toastId = $toast.data('toast-id');
    const localStorageKey = `toast-${toastId}`;

    updateTopOffset();
    $(window).on('resize', updateTopOffset);

    if (!localStorage.getItem(localStorageKey)) {
        setTimeout(() => {
            $toast.toast('show');
        }, 850);
    }
    $toast.on('hidden.bs.toast', () => {
        localStorage.setItem(localStorageKey, 'closed');
    });
}

/* das Mobile-Menue liegt innerhalb der .main-navbar und damit unter dem Popup -
   analog zur Notification-Bar wird das Popup deshalb ausgeblendet, solange es offen ist */
export function hideToast() {
    if ($infoToast) {
        $infoToast.css('display', 'none');
    }
}

export function showToast() {
    if ($infoToast) {
        $infoToast.css('display', '');
    }
}
